var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fail_status_24",
    transform: "translate(8169 4382)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24573",
    "data-name": "Rechteck 24573",
    width: 24,
    height: 24,
    transform: "translate(-8169 -4382)",
    fill: "rgba(102,102,102,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5561",
    "data-name": "Pfad 5561",
    d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm5.7,15.2-1.5,1.5L12,13.4,7.8,17.7,6.3,16.2,10.6,12,6.3,7.8,7.8,6.3,12,10.6l4.2-4.3,1.5,1.5L13.4,12Z",
    transform: "translate(-8169 -4382)",
    fill: "#d50000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError24);
export default __webpack_public_path__ + "static/media/Error_24.84cee05f8c73b08c651348166c39b510.svg";
export { ForwardRef as ReactComponent };